const custom_profile_fields = {
    table: {
        add_button: '添加资料字段',
        title: {
            field_label: '字段标签',
            type: '类型',
            user_data_key: '用户数据键名',
        },
        placeholder: {
            title: '收集用户资料',
            description: '自定义字段以在注册时收集更多用户资料信息。',
        },
    },
    type: {
        Text: '文本',
        Number: '数字',
        Date: '日期',
        Checkbox: '复选框(布尔值)',
        Select: '下拉框(单选)',
        Url: '网址',
        Regex: '正则表达式',
        Address: '地址(组合)',
        Fullname: '全名(组合)',
    },
    modal: {
        title: '添加资料字段',
        subtitle: '自定义字段以在注册时收集更多用户资料信息。',
        built_in_properties: '基础用户数据',
        custom_properties: '自定义用户数据',
        custom_data_field_name: '用户数据键名',
        custom_data_field_input_placeholder: '输入用户数据键名，例如 `myFavoriteFieldName`',
        custom_field: {
            title: '自定义数据',
            description: '你可以定义任何额外的用户属性以满足应用的独特需求。',
        },
        type_required: '请选择属性类型',
        create_button: '创建资料字段',
        avatar: {
            description: '允许用户在注册时上传头像，上传后的图片网址将保存为用户avatar。',
            storage_not_configured: 'Avatar上传需要先配置存储服务，请先配置storage后再添加此字段。',
        },
    },
    details: {
        page_title: '资料字段详情',
        back_to_sie: '返回登录体验',
        enter_field_name: '输入资料字段名称',
        delete_description: '此操作无法撤销。确定要删除此资料字段吗？',
        field_deleted: '资料字段 {{name}} 已成功删除。',
        key: '用户数据键名',
        field_name: '字段名称',
        field_type: '字段类型',
        settings: '设置',
        settings_description: '自定义字段以在注册时收集更多用户资料信息。',
        address_format: '地址格式',
        single_line_address: '单行地址',
        multi_line_address: '多行地址(例如：街道、城市、州、邮编、国家)',
        components: '组件',
        components_tip: '选择组成复杂字段的组件。',
        label: '字段标签',
        label_placeholder: '标签',
        label_tip: '需要本地化？在<a>登录体验 > 内容</a>中添加语言',
        label_tooltip: '浮动标签，用于指示字段用途。它初始显示在输入框内，在获得焦点或有值后上移到输入框上方。',
        placeholder: '字段占位符',
        placeholder_placeholder: '占位符',
        placeholder_tooltip: '输入框内的示例或格式提示。通常在标签上浮后显示，应保持简短（例如：MM/DD/YYYY）。',
        description: '字段描述',
        description_placeholder: '描述',
        description_tooltip: '显示在文本字段下方的辅助说明文本。适用于较长的操作指引或无障碍提示。',
        options: '选项',
        options_tip: '每行输入一个选项。使用value:label格式（例如red:红色）。也可以只写value；若未提供label，则显示时回退为该value。',
        options_placeholder: 'value1:label1\nvalue2:label2\nvalue3:label3',
        regex: '正则表达式',
        regex_tip: '定义正则表达式以验证输入。',
        regex_placeholder: '^[a-zA-Z0-9]+$',
        date_format: '日期格式',
        date_format_us: 'MM/dd/yyyy (例如：美国)',
        date_format_uk: 'dd/MM/yyyy (例如：英国和欧洲)',
        date_format_iso: 'yyyy-MM-dd (国际标准)',
        custom_date_format: '自定义日期格式',
        custom_date_format_placeholder: '输入自定义日期格式，例如 "MM-dd-yyyy"',
        custom_date_format_tip: '查看<a>date-fns</a>文档以获取有效的格式化标记。',
        input_length: '输入长度',
        value_range: '值范围',
        min: '最小值',
        max: '最大值',
        default_value: '默认值',
        checkbox_checked: '已选中(True)',
        checkbox_unchecked: '未选中(False)',
        required: '必填',
        required_description: '启用时，用户必须填写此字段。禁用时，此字段为可选。',
        avatar_upload_description: '终端用户在注册时上传头像，保存的值为上传后的图片网址。',
    },
};
export default Object.freeze(custom_profile_fields);
